import { useContext } from "react";
import { LocaleContext } from "context/LocaleContext";

export const useLocale = () => {
  const { localeState, localeActions } = useContext(LocaleContext);

  return { localeState, localeActions };
};
